import React, { useState, useEffect, useContext } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'

import Panel from './Panel'
import { Tabs, Tab } from './Tabs'
import TableData from './TableData'

import { withStyles } from '@material-ui/core/styles'

const styles = theme => ({
  root: {
  },
  titleText: {
    fontSize: theme.typography.h6.fontSize,
    fontWeight: 700
  }
})

const ListViewController = ({ theme, classes, ...props }) => {
  
  const { lastFetched, isFetching, fetchMoreData, rows, children, getRowsCount, hasMore } = props  
  const { title, actionButtons, backButton } = props
  
  const { groups, selectedGroupKey, onGroupChange } = props  
  
  return (
    <Panel 
      title={title}
      isMainPanel={true}      
      actionButtons={lastFetched && actionButtons}
      backButton={backButton}    
      inProgress={isFetching}    
      >
      { groups && groups.length > 0 &&
        <Tabs value={
            selectedGroupKey ? 
              groups.findIndex(g => g.key == selectedGroupKey) : 0
          }
          onChange={(e, newValue) => {
            if (onGroupChange)
              onGroupChange(groups[newValue])
          }}
          >
          { groups.map(g => (
            <Tab label={g.label + (typeof getRowsCount === 'function' ? ' (' + getRowsCount(g.key) + ')' : '')}
              />
          ))}        
        </Tabs>
      }
      
      { props.columns &&
        <div>
          <InfiniteScroll
            dataLength={ rows.length }
            next={fetchMoreData}
            hasMore={hasMore}
            // loader={<h4 style={{textAlign: 'center'}}>Please Wait...</h4>}
            style={{overflow:'inherit'}}
            > 
            <TableData {...props} />
            { children }

          </InfiniteScroll>
        </div>
      }
    </Panel>
  )
}

export default withStyles(styles, { withTheme: true })(
  ListViewController
)
